var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"l-icon",class:{ 'icon-animate': _vm.animate },attrs:{"src":_vm.getLikeIcon(_vm.flag),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }